export const STRIPE_KEY =
  "pk_test_51K3BgPALne365GO9bpuPcBHj71iMOtlaXxmJnIDr8MUzORa6ttGRZJbVSPlJYsWs5q9aau35irZxQW2BFhKpTTgn00601KwtYp";

export const STRIPE_LIVE_KEY =
  "pk_live_51K3BgPALne365GO9uUpB9rVgtKQWQssxsqtsOvg78GJRzE0TreWgLxuoO2LeIFWfiMh9NSc1rFOGchNVRjGWRBov00egGTl86x";

export const IOS_APP_LINK = "https://apps.apple.com/us/app/brigiz/id1600877394";

export const ANDROID_APP_LINK =
  "https://play.google.com/store/apps/details?id=com.brigiz.app";

export const LATITUDE = 27.6648;
export const LONGITUDE = 81.5158;

export const LOCATION_ERROR_MSG =
  "There are currently no registered business in your area☹️ \n\n Explore other Regions.";

export const GOOGLE_API_KEY = "AIzaSyAv1NXeIvFpcgy3zwAEC9h_vgTflroR6vw";

export const DAILY_DEAL = "DAILY_DEAL";
export const FEATURE_BUSINESS = "FEATURE_BUSINESS";
export const LOCAL_HIGHLIGHT = "LOCAL_HIGHLIGHT";
export const NEW_BUSINESS = "NEW_BUSINESS";
export const HOME_PAGE_DATA_LIST = "HOME_PAGE_DATA_LIST";
export const BUSINESS_TYPE_LIST = "BUSINESS_TYPE_LIST";
export const BUSINESS_LIST = "BUSINESS_LIST";
export const BUSINESS_SEARCH = "BUSINESS_SEARCH";
export const BUSINESS_ADS = "BUSINESS_ADS";
export const NEW_INTEREST = "NEW_INTEREST";
export const FAVORITES_LIST = "FAVORITES_LIST";
export const UPDATE_INTEREST_SUCCESS = "UPDATE_INTEREST_SUCCESS";
export const UPDATE_INTEREST_ERROR = "UPDATE_INTEREST_ERROR";
export const CATEGORY_BUSINESS = "CATEGORY_BUSINESS";

export const SIGN_UP_TYPE = {
  REGULAR: "Regular",
  GOOGLE: "Google",
  FACEBOOK: "Facebook",
  APPLE: "Apple",
  PHONE: "Phone",
};

export const HTTP_ERROR_MESSAGES = {
  400: "Bad Request",
  401: "Unauthorized",
  403: "Forbidden",
  404: "Not Found",
  409: "Conflict",
  413: "Request Entity Too Large",
  500: "Internal Server Error",
  503: "Service Unavailable",
};

export const BUSINESS_TYPE_SIGN_IN = 'Business'
export const CUSTOMER_TYPE_SIGN_IN = 'Customer'

export const FACEBOOK_REGEX = /(?:https?:\/\/)?(?:www\.)?(?:facebook|fb)\.com\/(?!(?:[A-Za-z]+\.php|marketplace|gaming|watch|me|messages|help|search|groups)\/?)([A-Za-z0-9_.\-]+)\/?/
export const INSTAGRAM_REGEX = /(?:https?:\/\/)?(?:www\.)?(?:instagram\.com|instagr\.am)\/([A-Za-z0-9_](?:(?:[A-Za-z0-9_]|(?:\.(?!\.))){0,28}[A-Za-z0-9_])?)\/?/
export const LINKEDIN_REGEX = /(?:https?:\/\/)?(?:[\w]+\.)?linkedin\.com\/([\w\-]+)(?:\/([A-Za-z0-9\-À-ÿ\.]+))?/
export const TWITTER_REGEX = /(?:https?:\/\/)?(?:www\.)?(?:twitter\.com|t\.co|x\.com)\/([A-Za-z0-9_@]+(?:\/[A-Za-z0-9_\/\-]+)?)\/?/
export const YOUTUBE_REGEX = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:(?:watch\?v=|channel\/|user\/|c\/|@)|(?:shorts\/))|youtu\.be\/)([A-Za-z0-9\-_@]+)/
export const TICKTOCK_REGEX = /https?:\/\/(?:www\.)?tiktok\.com\/(@[a-zA-Z0-9._]+|video\/\d+)/
export const WEBSITE_REGEX = /^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?\/?$/




export const FIREBASE_DEV_URL = 'https://brigiz-preprod.firebaseio.com/'
export const FIREBASE_STAGING_URL = 'https://brigiz-staging.firebaseio.com/'
export const FIREBASE_PROD_URL = 'https://brigiz-default-rtdb.firebaseio.com/'

export const BRIGIZ_APP_E_COM_HOME = `${process.env.REACT_APP_E_COM_HOME}`
export const BRIGIZ_APP_E_COM_TRACK_ORDER = `${process.env.REACT_APP_E_COM_HOME}tracking-order`
export const BRIGIZ_APP_E_COM_COMPARE_PRODUCT = `${process.env.REACT_APP_E_COM_HOME}products-compaire`
export const BRIGIZ_APP_E_COM_CART = `${process.env.REACT_APP_E_COM_HOME}cart`
export const BRIGIZ_APP_E_COM_ORDER = `${process.env.REACT_APP_E_COM_HOME}profile?website=true#order`
export const BRIGIZ_APP_E_COM_ADDRESS = `${process.env.REACT_APP_E_COM_HOME}profile?website=true#address`
export const BRIGIZ_APP_E_COM_WISHLIST = `${process.env.REACT_APP_E_COM_HOME}profile?website=true#wishlist`